export default function Footer() {
  return (
    <footer className="border-t border-[#E5E7EB] dark:border-[#1e2536] bg-[#F8F9FA] dark:bg-[#0a0d14] mt-auto py-4 px-5" style={{ fontFamily: 'var(--font-sans)' }}>
      <div className="flex items-center justify-between flex-wrap gap-2">
        <p className="text-[12px] text-[#6B7280] dark:text-[#505a6e]">
          For informational purposes only. Not financial advice. Please gamble responsibly.
        </p>
        <p className="text-[12px] text-[#9CA3AF] dark:text-[#505a6e]">
          &copy; {new Date().getFullYear()} AI Sports Edge
        </p>
      </div>
    </footer>
  );
}
